import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AxiosInstance from "../Home/AxiosInstance";

const UpdateProfile = () => {
  const { state } = useLocation();
  const { user } = state || {};
  const navigate = useNavigate();

  const [firstName, setFirstName] = useState(user?.firstName || "");
  const [lastName, setLastName] = useState(user?.lastName || "");
  const [aliasName, setAliasName] = useState(user?.aliasName || "");
  const [email, setEmail] = useState(user?.email || "");
  const [mobileNo, setMobileNo] = useState(user?.mobileNo || "");
  const [dob, setDOB] = useState(user?.dob || "");
  const [gender, setGender] = useState(user?.gender?.toLowerCase() || "");
  const [about, setAbout] = useState(user?.about || "");
  const [imagePath, setImagePath] = useState(user?.imagePath || "");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!user) navigate("/");
  }, [user, navigate]);

  const closeModal = () => navigate("/my-details");

  const handleProfileUpdate = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const userId = localStorage.getItem("userId");

    const formData = new FormData();
    formData.append("first_name", firstName);
    formData.append("last_name", lastName);
    formData.append("alias_name", aliasName);
    formData.append("email", email);
    formData.append("mobile_no", mobileNo);
    formData.append("dob", dob);
    formData.append("gender", gender);
    formData.append("about", about);
    if (imagePath && typeof imagePath === "object") {
      formData.append("image_path", imagePath);
    }

    try {
      const res = await AxiosInstance.put(
        `companies/user/update/${userId}/`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (res.status === 200) {
        alert("Profile updated successfully!");
        navigate("/my-details");
      } else {
        alert("Failed to update profile.");
      }
    } catch (err) {
      console.error("Profile update error:", err);
      alert("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {/* Modal backdrop */}
      <div className="modal-backdrop fade show"></div>

      <div
        className="modal d-block"
        tabIndex="-1"
        role="dialog"
        style={{ backgroundColor: "rgba(0, 0, 0, 0.3)" }}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Profile</h5>
            </div>

            <div
              className="modal-body"
              style={{ maxHeight: "70vh", overflowY: "auto" }}
            >
              <form onSubmit={handleProfileUpdate}>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label">First Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Last Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label">Alias Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={aliasName}
                      onChange={(e) => setAliasName(e.target.value)}
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Date of Birth</label>
                    <input
                      type="date"
                      className="form-control"
                      value={dob}
                      onChange={(e) => setDOB(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Mobile No</label>
                    <input
                      type="text"
                      className="form-control"
                      value={mobileNo}
                      onChange={(e) => setMobileNo(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">Gender</label>
                  <select
                    className="form-select"
                    value={gender}
                    onChange={(e) => setGender(e.target.value)}
                    required
                  >
                    <option value="">Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label">About</label>
                  <textarea
                    className="form-control"
                    value={about}
                    onChange={(e) => setAbout(e.target.value)}
                    rows={4}
                    placeholder="Write something about yourself... Use '-' or '*' for bullet points on new lines."
                    required
                  ></textarea>
                  <small className="form-text text-muted mt-1">
                    Use '-' or '*' at the beginning of a line for bullet points.
                  </small>
                </div>

                <div className="mb-3">
                  <label className="form-label">Profile Image</label>
                  <input
                    type="file"
                    className="form-control"
                    accept="image/*"
                    onChange={(e) => setImagePath(e.target.files[0])}
                  />
                  {imagePath && typeof imagePath === "object" && (
                    <div className="form-text mt-1">
                      Selected: {imagePath.name}
                    </div>
                  )}
                </div>

                <div className="d-flex justify-content-end gap-2">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isLoading}
                  >
                    {isLoading ? "Saving..." : "Update Profile"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateProfile;
